// extracted by mini-css-extract-plugin
module.exports = {"itemContainer":"ShipmentsListView_itemContainer__3-6wg","rowWrapToColumn":"ShipmentsListView_rowWrapToColumn___SBrJ","noRowsToShow":"ShipmentsListView_noRowsToShow__1dVc8"};